module.exports = __webpack_public_path__ + "img/people_alt-24px.678b8239.svg";